import React from 'react';

import { QuickFilter } from '../../CustomerLaneCommitsBoard/QuickFilters/QuickFilters';
import { orderQuickFilters } from '../filterBarSettings';

// A report's or dashboard's quick filters, as pills the viewer toggles
const QuickFilterPills = ({
  quickFilters,
  quickFilterOrder,
  selectedQuickFilters,
  setSelectedQuickFilters,
}: {
  quickFilters: LegacySavedFilter[];
  quickFilterOrder: string[];
  selectedQuickFilters: LegacySavedFilter[];
  setSelectedQuickFilters: React.Dispatch<
    React.SetStateAction<LegacySavedFilter[]>
  >;
}) => {
  const onFilterToggled = (filter: LegacySavedFilter) => {
    const isSelected = selectedQuickFilters.some((f) => f.id === filter.id);
    if (isSelected) {
      setSelectedQuickFilters((fs) => fs.filter((f) => f.id !== filter.id));
    } else {
      setSelectedQuickFilters((fs) => [...fs, filter]);
    }
  };

  // Fragment (not a wrapper div) so pills are direct flex children of the
  // filter bar and participate in its flex-wrap layout.
  return (
    <>
      {orderQuickFilters({ quickFilters, quickFilterOrder }).map((f) => (
        <QuickFilter
          key={f.id}
          onClick={() => onFilterToggled(f)}
          isSelected={selectedQuickFilters.some((sf) => sf.id === f.id)}
          name={f.name || 'Filter'}
        />
      ))}
    </>
  );
};

export default QuickFilterPills;
